import { atom } from 'jotai';
import { TopMenuProps } from '../../../../ts';

const DEFAULT_TOP_MENU_PROPS: TopMenuProps = {
  title: '',
};

export const topMenuPropsAtom = atom<TopMenuProps>(DEFAULT_TOP_MENU_PROPS);
